type EnterpriseValues = string;

type PlanValues = {
  label: string;
  highlight: boolean;
  strong: boolean;
  enterprise1: EnterpriseValues;
  enterprise2: EnterpriseValues;
  enterprise3: EnterpriseValues;
};

export type PlanDetails = {
  module: string;
  description?: string;
  values: PlanValues[];
};

export const createNewPlans = (): PlanDetails[] => {
  return [
    {
      module: 'Quantidade de Placas',
      values: [
        {
          label: 'Até 40 (mínimo mensal)',
          enterprise1: 'R$ 369,00',
          enterprise2: 'R$ 549,00',
          enterprise3: 'R$ 649,00',
          highlight: false,
          strong: true
        },
        {
          label: '41 a 99 veículos (por placa)',
          enterprise1: 'R$ 8,81',
          enterprise2: 'R$ 13,30',
          enterprise3: 'R$ 15,80',
          highlight: false,
          strong: false
        },
        {
          label: '100 a 199 veículos (por placa)',
          enterprise1: 'R$ 7,57',
          enterprise2: 'R$ 12,07',
          enterprise3: 'R$ 14,57',
          highlight: false,
          strong: false
        },
        {
          label: '200 a 499 veículos (por placa)',
          enterprise1: 'R$ 4,65',
          enterprise2: 'R$ 9,15',
          enterprise3: 'R$ 11,65',
          highlight: false,
          strong: false
        },
        {
          label: '500 a 999 veículos (por placa)',
          enterprise1: 'R$ 4,28',
          enterprise2: 'R$ 8,78',
          enterprise3: 'R$ 11,28',
          highlight: false,
          strong: false
        },
        {
          label: '1.000 a 4.999 veículos (por placa)',
          enterprise1: 'R$ 3,64',
          enterprise2: 'R$ 6,78',
          enterprise3: 'R$ 9,28',
          highlight: false,
          strong: false
        },
        {
          label: 'Acima 5.000 veículos (por placa)',
          enterprise1: 'R$ 3,09',
          enterprise2: 'R$ 5,76',
          enterprise3: 'R$ 7,89',
          highlight: false,
          strong: false
        }
      ]
    },
    {
      module: 'Valores adicionais',
      description: '(cobrados por utilização)',
      values: [
        {
          label: 'Valor por indicação de condutor *',
          enterprise1: 'R$ 12,90',
          enterprise2: 'R$ 0,00',
          enterprise3: 'R$ 0,00',
          highlight: false,
          strong: false
        },
        {
          label: 'Taxa por transação de pagamento *',
          enterprise1: '5%',
          enterprise2: '0%',
          enterprise3: '0%',
          highlight: false,
          strong: false
        },
        {
          label: 'Valor por consulta de CNH *',
          enterprise1: 'R$ 1,80',
          enterprise2: 'R$ 1,80',
          enterprise3: 'R$ 0,00',
          highlight: false,
          strong: false
        },
        {
          label: 'Consulta ANTT (por CNPJ adicional)',
          enterprise1: 'R$ 150,00',
          enterprise2: 'R$ 150,00',
          enterprise3: 'R$ 150,00',
          highlight: false,
          strong: false
        }
      ]
    },
    {
      module: 'Funcionalidades',
      values: [
        {
          label: 'Dashboard',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: true,
          strong: false
        },
        {
          label: 'Geral',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Multas',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Condutores',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Veículos',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Licenças',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Frotas',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: true,
          strong: false
        },
        {
          label:
            'IPVA / Licenciamento\n(BA, CE, ES, GO, MG, PR, RJ, RS, SC e SP)',
          enterprise1: '❌',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Veículos',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Condutores',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Viagens',
          enterprise1: '❌',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Multas',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: true,
          strong: false
        },
        {
          label: 'Notificação',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Infrações',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Infrações ANTT (Embarcador)',
          enterprise1: '1 CNPJ',
          enterprise2: '3 CNPJs',
          enterprise3: '5 CNPJs',
          highlight: false,
          strong: false
        },
        {
          label: 'Relatórios',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: true,
          strong: false
        },
        {
          label: 'Veículos',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Condutores',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Multas',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Notificações',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Pagamento',
          enterprise1: '⚠️*',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: true,
          strong: false
        },
        {
          label: 'Conta',
          enterprise1: '⚠️*',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Pagamento de Multas',
          enterprise1: '⚠️*',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Configurações',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: true,
          strong: false
        },
        {
          label: 'Usuários',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Grupo de Usuários',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Ajuda',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: true,
          strong: false
        },
        {
          label: 'Frota Academy',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Consulta de Cronotacógrafo',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Gestão de Licenças',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Consulta de CNH',
          enterprise1: '⚠️*',
          enterprise2: '⚠️*',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Indicação de Condutor On-line',
          enterprise1: '⚠️*',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Integração SNE',
          enterprise1: '❎',
          enterprise2: '❎',
          enterprise3: '❎',
          highlight: false,
          strong: false
        },
        {
          label: 'Emissão CRLV',
          enterprise1: '❌',
          enterprise2: '❌',
          enterprise3: '❎',
          highlight: false,
          strong: false
        }
      ]
    }
  ];
};
